import * as React from "react";
import cx from "classnames";
import TrendingSection from "../trendingSection";
import useDiscoverSlideHook from "app/discover/helpers/useDiscoverSlide";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import TrackTicket, { TICKET_TYPE } from "@vingle/wtf-sdk/helpers/trackTicket";
import { VingleURL } from "@vingle/wtf-sdk/url";

const styles = require("./trendingSectionSlide.scss");

interface IProps {
  sections: Vingle.Discover.ITrendingSection[];
  selectedSectionId?: string | null;
  onClickSection?: (
    section: Vingle.Discover.ITrendingSection,
    event: React.MouseEvent,
  ) => void;
}

const MOVE_SLIDE_SIZE = 1;
const SHOW_SLIDE_SIZE = 3;

function useTrendingSectionSlide(props: IProps) {
  const { sections } = props;
  const slideHook = useDiscoverSlideHook(
    sections,
    MOVE_SLIDE_SIZE,
    SHOW_SLIDE_SIZE,
  );
  const { slidePosition } = slideHook;
  const showSlidePosition = [
    slidePosition,
    slidePosition + 1,
    slidePosition + 2,
  ];
  const [sendSlidePosition, setSendSlidePosition] = React.useState<number[]>(
    () => [],
  );
  React.useEffect(() => {
    if (sections.length) {
      setSendSlidePosition(
        showSlidePosition
          .filter(position => !sendSlidePosition.includes(position))
          .map(position => {
            TrackTicket.sharedInstance().stackTicket(TICKET_TYPE.ACTION, {
              content: {
                type: "trending_section",
                id: sections[position] && sections[position].id,
              },
              action: {
                type: "impression",
              },
              referral_url: new VingleURL.Discover().toSchema(),
              position,
            });
            return position;
          })
          .concat(sendSlidePosition),
      );
    }
  }, [showSlidePosition, sections]);
  return {
    ...slideHook,
    showSlidePosition,
  };
}

export default React.memo(function TrendingSectionSlide(props: IProps) {
  const { sections, selectedSectionId, onClickSection } = props;
  const {
    slidePosition,
    isDisabledPrev,
    handleMovePrev,
    isDisabledNext,
    handleMoveNext,
    slideStyle,
    showSlidePosition,
  } = useTrendingSectionSlide(props);
  return (
    <div className={styles.container}>
      <button
        disabled={isDisabledPrev}
        onClick={handleMovePrev}
        className={styles.slidePrevButton}
      >
        <IconWrapper
          icon={PACKS.TRENDING_DISCOVER.SUMMARY_CARD_ARROW}
          tagName="span"
          className={styles.slideMoveIcon}
        />
      </button>
      <button
        disabled={isDisabledNext}
        onClick={handleMoveNext}
        className={styles.slideNextButton}
      >
        <IconWrapper
          icon={PACKS.TRENDING_DISCOVER.SUMMARY_CARD_ARROW}
          tagName="span"
          className={styles.slideMoveIcon}
        />
      </button>
      <div className={styles.slide}>
        <div className={styles.wrapper} style={slideStyle}>
          {sections.map((section, index) => {
            return (
              <div
                className={cx(styles.item, {
                  [styles.left]: slidePosition === index,
                  [styles.center]: slidePosition + 1 === index,
                  [styles.right]: slidePosition + 2 === index,
                  [styles.hidden]: !showSlidePosition.includes(index),
                })}
                key={section.id}
              >
                {selectedSectionId !== section.id ? (
                  <TrendingSection
                    section={section}
                    onClickSection={onClickSection}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
